import { createContext } from 'react';

type AssetModalAPI = {
  handleOnFinishEditing: () => void;
};

const AssetModalContext = createContext<AssetModalAPI | undefined>(undefined);

export default AssetModalContext;
